// What the AI allowance looks like for the current account, from the company payload
// (ai_quota_* and trial_ai_* come from Company#as_json). Only Grátis (monthly) and the
// trial have an allowance that subscribing raises; paid plans get 50 a day.
export const AI_UNITS = { transcription: 2, quickNoteAudio: 3, organize: 1 };
export const LOW_QUOTA = 6;

export function aiQuota(company) {
  const c = company || {};
  const trial = !!c.trial_ai_limit;
  const period = c.ai_quota_period || "day";
  const remaining =
    typeof c.ai_quota_remaining === "number" ? c.ai_quota_remaining : null;
  return {
    remaining,
    period,
    trial,
    // Subscribing helps only on Grátis (month) or in the trial.
    upgradeHelps: period === "month" || trial,
  };
}

// True when the account already knows it can't afford `units` (and subscribing would help).
export function aiQuotaShort(company, units) {
  const q = aiQuota(company);
  return q.upgradeHelps && q.remaining !== null && q.remaining < units;
}

// "Restam 4 ações de IA este mês" when the allowance is low; "" otherwise.
export function aiQuotaHint(company) {
  const q = aiQuota(company);
  if (!q.upgradeHelps || q.remaining === null || q.remaining > LOW_QUOTA)
    return "";
  if (q.remaining === 0)
    return q.trial
      ? "As ações de IA do teste acabaram."
      : "As ações de IA do mês acabaram.";
  const one = q.remaining === 1;
  const n = `${q.remaining} ${one ? "ação" : "ações"} de IA`;
  const verb = one ? "Resta" : "Restam";
  return q.trial ? `${verb} ${n} do teste.` : `${verb} ${n} este mês.`;
}

// Title of the "not enough AI" step before recording: "acabaram" only when nothing is left.
export function aiGateTitle(company) {
  const q = aiQuota(company);
  if (q.remaining) {
    const n = `${q.remaining} ${q.remaining === 1 ? "ação" : "ações"} de IA`;
    return `${q.remaining === 1 ? "Resta só" : "Restam só"} ${n} ${q.trial ? "do teste" : "este mês"}`;
  }
  return q.trial ? "As ações de IA do teste acabaram" : "As ações de IA do mês acabaram";
}

// "12 min" / "40 s" for the message about a recording that is waiting.
export function durationLabel(seconds) {
  const s = Math.round(seconds || 0);
  if (s < 60) return `${s} s`;
  return `${Math.round(s / 60)} min`;
}
